import React from "react";

import MainTemplate from "@/components/Templates/MainTemplate";
import Button from "@/components/Atoms/Button";
// import Form from "./Form";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";
import { isMobile } from "@/utils";

import {
  BannerContainer,
  PageWrapper,
  FormContainer,
  FormBanner,
  SubTitle,
  Title,
  FormTitle,
} from "./style";

function FestivalBanner() {
  const title = (
    <FormTitle
      color={
        isMobile
          ? theme.colorsV2.rose.shade_300
          : theme.colorsV2.warning.shade_600
      }
      variant={isMobile ? "heading1" : "display1"}
      fontSize={["18px", "24px", "32px"]}
      lineHeight={["24px", "32px", "40px"]}
      fontWeight="700"
      mb="10px"
      mt={isMobile && "32px"}
    >
      Click the download button to get your copy of the Diwali Cheat sheet
      instantly!
    </FormTitle>
  );

  const subtitle = (
    <Typography
      maxWidth={["261px", "100%"]}
      color={theme.colorsV2.blueGray.shade_700}
      variant="paragraph1"
      fontSize={["14px", "14px", "16px"]}
      lineHeight={["20px", "20px", "22px"]}
    >
      A quick and practical guide to making your festive season healthier by
      incorporating small and easy changes
    </Typography>
  );

  const downloadButton = (
    <Button
      variant={"primary"}
      onClick={() => {
        const filePath =
          "https://d1mxd7n691o8sz.cloudfront.net/static/website/diwali-content/ShyftDiwaliCheatSheet.pdf";
        window.open(filePath, "_blank");
      }}
      btnPadding={isMobile ? "16px 40px" : "22px 56px"}
      textAlign={"center"}
      fontSize={isMobile ? "16px" : "18px"}
      fontFamily="var(--font-700)"
      style={{ zIndex: 5 }}
      mt="16px"
    >
      Download the Cheatsheet
    </Button>
  );

  return (
    <MainTemplate>
      <PageWrapper>
        <BannerContainer>
          <Title
            color={theme.colorsV2.rose.shade_300}
            variant="heading1"
            fontSize={["24px", "24px", "42px"]}
            lineHeight={["32px", "32px", "57px"]}
            mb={["8px", "8px", "16px"]}
          >
            This Diwali, cheat your way to good health!
          </Title>
          <SubTitle
            color={theme.colorsV2.shyft.cream}
            variant="paragraph1"
            fontSize={["14px", "14px", "16px"]}
            lineHeight={["20px", "20px", "22px"]}
          >
            While Diwali is a great time to let loose, celebrate, and gorge on
            our most favourite food, it does not have to come at the expense of
            your health and well-being.
            <br />
            <br />
            Stay on track with practical tips from Clinical Nutritionists,
            Doctors, and Yoga Experts.
          </SubTitle>
          {isMobile && (
            <>
              {title}
              {downloadButton}
            </>
          )}
        </BannerContainer>
        {!isMobile && (
          <FormContainer>
            <FormBanner>
              {title}
              {subtitle}
              {downloadButton}
            </FormBanner>
            {/* <Form /> */}
          </FormContainer>
        )}
      </PageWrapper>
    </MainTemplate>
  );
}

export default FestivalBanner;
